import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkAsButton } from '@printdeal/ui-library';
import OpenDeliveryToolButton from '../../../shared/Actions/DeliverFiles/OpenDeliveryToolButton';
import LineItem from '../../../../../../types/cart/LineItem';
import { DeliveryToolSettings } from '../../../../../../types/file-delivery/FileDelivery';
import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface EditFilesButtonProps {
  lineItem: LineItem,
  orderId: string,
  deliveryToolSettings: DeliveryToolSettings,
}

const EditFilesButton = ({
  lineItem,
  orderId,
  deliveryToolSettings,
}: EditFilesButtonProps) => (
  <OpenDeliveryToolButton
    lineItem={lineItem}
    orderId={orderId}
    deliveryToolSettings={deliveryToolSettings}
    isEdit
  >
    <LinkAsButton
      as="button"
      variant="secondary"
      iconBefore="edit"
      onClick={() => dispatchAccountEvent('order_detail_interaction', 'open_file_edit')}
      className="pd-text-xs"
    >
      <FormattedMessage id="account.order.deliverFiles.edit" defaultMessage="Edit design" />
    </LinkAsButton>
  </OpenDeliveryToolButton>
);

export default EditFilesButton;
